<template>
  <v-container fluid fill-height style="align-items: start !important">
    
    <v-flex xs12>

      <v-layout row wrap>

      <v-card :class="fondoTitle" style="width: 100%">

        <v-toolbar dark style="height: 100px; background: transparent">
          <v-toolbar-title class="texto">
            <i class="material-icons" style="color: white; float: left; margin-right: 10px;">
            desktop_mac
            </i>            
            MONITORIZACIÓN DE LAS COLAS                    
            </v-toolbar-title>  
            <v-spacer></v-spacer>
            <v-btn 
              v-show="view_filter_queues" icon 
              @click="filterExtension = '' , view_filter_queues = !view_filter_queues">
              <v-icon style="font-size: 15px">close</v-icon>
            </v-btn>   
            <v-text-field
              autofocus
              v-if="view_filter_queues"
              v-model="filterExtension"
            ></v-text-field> 
            <v-tooltip left>
            <v-btn slot="activator" icon @click="view_filter_queues = !view_filter_queues">
              <v-icon>filter_list</v-icon>
            </v-btn> 
            <span>FILTRAR AGENTE</span>
            </v-tooltip>           
        </v-toolbar>
        
        <div style="position: absolute;
          right: 10px;
          left: 10px;
          top: 55px;">
          <v-layout row wrap> 

          <v-flex style="width: 20%" v-for="(cola, index) in colas" :key="index">

            <v-card style="border: 3px solid #ececec; margin: 2px;">

              <v-toolbar 
                :style="getStyleTitleCola(cola.name)"
                dark>
                <v-tooltip left>
                <v-btn slot="activator" @click="openAddAgentQueue(cola.name)" icon style="margin: 0px;">
                  <v-icon color="white" style="font-size: 30px">playlist_add</v-icon>
                </v-btn> 
                <span>AÑADIR AGENTE A LA COLA</span>
                </v-tooltip> 
                <v-toolbar-title>{{cola.name_print}}</v-toolbar-title>
                <v-spacer></v-spacer>

                <!-- Información del DDI -->
                <span class="hidden-md-and-down" v-if="cola.ddi" style="font-size: 18px;"> {{cola.ddi}}</span> <i v-if="cola.ddi" class="material-icons hidden-md-and-down" style="font-size: 20px; padding-bottom: 5px; margin-left:3px"> phone </i>
                
                <v-tooltip left>
                <v-btn slot="activator" flat icon 
                  color="grey" 
                  v-if="cola.name === 'Contingencia' && calipsoStatus"
                  style="margin-top: 1px;">
                  OFF
                  <v-icon style="font-size: 45px">toggle_off</v-icon>
                </v-btn>
                <span>COLA NO ACTIVA, LOS TRABAJOS LOS ASIGNA CALIPSO</span>
                </v-tooltip>
                <v-tooltip left>
                <v-btn slot="activator" flat icon 
                  color="white1" 
                  v-if="cola.name === 'Contingencia' && !calipsoStatus"
                  style="margin-top: 1px;">
                  ON
                  <v-icon style="font-size: 45px">toggle_on</v-icon>
                </v-btn>
                <span>COLA ACTIVA. CALIPSO DESACTIVADO</span>
                </v-tooltip>                
              </v-toolbar>

              <v-card-title style="padding: 0px; background: #e0e0e0">

              <!-- // ? LLAMADAS -->
              <v-flex xs6 v-bind:style="{  'height': colas_height + 'px', 'overflow':'auto' }">              
                <v-list style="padding-top: 0px;width:100%;  background: #e0e0e0">
                <v-subheader
                  style="height: 18px; justify-content: center; font-size: 14px;">
                {{cola.llamadas.length}} En espera
                </v-subheader> 
                <v-divider></v-divider>               
                  <template v-for="(item, index) in cola.llamadas">
                  <v-list-tile 
                        :style="getStyleLlamadas(item)" 
                        :key="index"
                        avatar>

                      <v-btn icon style="margin: 0px;">
                        <v-icon color="white" style="font-size: 20px">local_phone</v-icon>
                      </v-btn>                

                      <v-list-tile-content style="height: 40px; font-size: 15px">
                        <v-list-tile-title v-html="item.number"></v-list-tile-title>
                      </v-list-tile-content>

                    </v-list-tile>
                  </template>
                </v-list>
              </v-flex>

              <!-- AGENTES -->
              <v-flex xs6 v-bind:style="{  'height': colas_height + 'px', 'overflow':'auto' }" style="border-left: 0.2px solid rgba(0,0,0,.54);">        
                <v-list style="padding-top: 0px; width:100%; padding-bottom: 0px; background: #e0e0e0;">
                  <v-subheader style="height: 18px; justify-content: center; font-size: 14px;"> {{ numeroAgentesDisponibles(cola) }} Agentes libres </v-subheader>              
                  <v-divider></v-divider>  
                  <template>  

                  <!--  // ? AGENTES LIBRES -->
                  <v-list-tile 
                    v-for="(item, index) in filterAgentesLibresColas(cola)" 
                    :style="getStyleAgenteQueue(item)"                              
                    :key="index"
                    avatar>

                      <v-list-tile-content style="width: 70%;; height: 40px; padding-left: 10px; cursor: pointer" @click="getInfoLoginHistoryExtension(item.extension)">
                        <v-list-tile-title v-html="item.extension"></v-list-tile-title>
                      </v-list-tile-content>

                      <v-btn icon style="margin: 0px; margin-top: 0px; cursor: pointer" v-if="item.calipso" @click="infoColasExtension(item.extension)">
                        <v-icon color="white" style="font-size: 22px;">copyright</v-icon>
                      </v-btn> 

                      <v-spacer></v-spacer>

                      <v-tooltip left>
                      <v-btn slot="activator" icon style="margin: 0px;">
                        <v-icon color="white" @click="prevLogoutColas(cola.name, item.extension)" style="font-size: 20px;">exit_to_app</v-icon>
                      </v-btn>                      
                      <span>SACAR AGENTE DE LA COLA</span>
                      </v-tooltip> 

                    </v-list-tile>

                    <!--  // ? AGENTES EN LLAMADA -->
                    <v-list-tile 
                      v-for="(item) in filterAgentesEnLlamadaColas(cola)" 
                      :style="getStyleAgenteQueue(item)"                              
                      :key="item.extension"
                      avatar>

                        <v-list-tile-content style="width: 70%;; height: 40px; padding-left: 10px; cursor: pointer" @click="getInfoLoginHistoryExtension(item.extension)">
                          <v-list-tile-title v-html="item.extension"></v-list-tile-title>
                        </v-list-tile-content>

                        <v-btn icon style="margin: 0px; margin-top: 0px; cursor: pointer" v-if="item.calipso" @click="infoColasExtension(item.extension)">
                          <v-icon color="white" style="font-size: 22px;">copyright</v-icon>
                        </v-btn> 

                        <v-spacer></v-spacer>

                        <v-tooltip left>
                        <v-btn slot="activator" icon style="margin: 0px;">
                          <v-icon color="white" @click="prevLogoutColas(cola.name, item.extension)" style="font-size: 20px;">exit_to_app</v-icon>
                        </v-btn>                      
                        <span>SACAR AGENTE DE LA COLA</span>
                        </v-tooltip> 

                      </v-list-tile>

                    <!--  // ? AGENTES PAUSADOS -->
                    <v-list-tile 
                      v-for="(item) in filterAgentesPausadosColas(cola)" 
                      :style="getStyleAgenteQueue(item)"                              
                      :key="item.extension"
                      avatar>

                        <v-list-tile-content style="width: 70%;; height: 40px; padding-left: 10px; cursor: pointer" @click="getInfoLoginHistoryExtension(item.extension)">
                          <v-list-tile-title v-html="item.extension"></v-list-tile-title>
                        </v-list-tile-content>

                        <v-btn icon style="margin: 0px; margin-top: 0px; cursor: pointer" v-if="item.calipso" @click="infoColasExtension(item.extension)">
                          <v-icon color="white" style="font-size: 22px;">copyright</v-icon>
                        </v-btn> 

                        <v-spacer></v-spacer>

                        <v-tooltip left>
                        <v-btn slot="activator" icon style="margin: 0px;">
                          <v-icon color="white" @click="prevLogoutColas(cola.name, item.extension)" style="font-size: 20px;">exit_to_app</v-icon>
                        </v-btn>                      
                        <span>SACAR AGENTE DE LA COLA</span>
                        </v-tooltip> 

                      </v-list-tile>

                    <!--  // ? AGENTES BUSY O NO REGISRTADOS -->
                    <v-list-tile 
                      v-for="(item, index) in filterAgentesOcupadosNoRegistradosColas(cola)" 
                      :style="getStyleAgenteQueue(item)"                              
                      :key="item.extension + index"
                      avatar>

                        <v-list-tile-content style="width: 70%;; height: 40px; padding-left: 10px; cursor: pointer" @click="getInfoLoginHistoryExtension(item.extension)">
                          <v-list-tile-title v-html="item.extension"></v-list-tile-title>
                        </v-list-tile-content>

                        <v-btn icon style="margin: 0px; margin-top: 0px; cursor: pointer" v-if="item.calipso" @click="infoColasExtension(item.extension)">
                          <v-icon color="white" style="font-size: 22px;">copyright</v-icon>
                        </v-btn> 

                        <v-spacer></v-spacer>

                        <v-tooltip left>
                        <v-btn slot="activator" icon style="margin: 0px;">
                          <v-icon color="white" @click="prevLogoutColas(cola.name, item.extension)" style="font-size: 20px;">exit_to_app</v-icon>
                        </v-btn>                      
                        <span>SACAR AGENTE DE LA COLA</span>
                        </v-tooltip> 

                      </v-list-tile>                      

                  </template>
                </v-list>
              </v-flex>

              </v-card-title>

            </v-card>

          </v-flex> 

          </v-layout>
        </div>
      </v-card>

      </v-layout>

    </v-flex>

    <!-- DIALOG INFO LOGIN HISTORY -->
    <v-dialog v-model="dialog_info_login" scrollable max-width="50%">
      <v-card>
        <v-card-title>
          <span class="title">Extensión {{current_extension}}</span>
          <v-spacer></v-spacer>
          <span class="title">Login history & Settings</span>
        </v-card-title>
        <v-card-text style="height: 530px;">
         
          <v-card>

            <v-card-title>
              <span style="font-size: 15px;">
                <i class="material-icons" style="float: left; margin-right: 5px; color: #039BE5"> info </i>
                {{dialog_title}}
              </span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="headline">
              <pre>{{dialog_content}}</pre>
            </v-card-text>
            <v-divider></v-divider>

            <v-card-title>

            <v-btn 
              v-if="!current_extension_login"
              style="background: linear-gradient(45deg,#6FE594,#27A47C); color: white;" 
              flat="flat" @click="login()">
              <v-icon left dark style="margin-right: 5px">power</v-icon> LOGIN</v-btn>   
            <v-btn 
              v-else
              style="background: linear-gradient(45deg,#F1467A,#FB949E); color: white;" 
              flat="flat" @click="logout()">
              <v-icon left dark style="margin-right: 5px">power_off</v-icon> LOGOUT</v-btn>   

              <v-spacer></v-spacer>
              <v-text-field
                v-model="searchHistory"
                append-icon="search"
                label="Buscar"
                color="blue lighten-2"
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="filterLoginHistory"
              :pagination.sync="pagination"
              rows-per-page-text="Filas por página"
              :must-sort="true"
              :loading="true"
              no-data-text="No hay registro de intentos de login o logout."
            >
              <template slot="items" slot-scope="props">          
                <!-- <tr :class="{ danger: !props.item.resultado }">      -->
                <tr>     
                  <td class="text-xs-left">{{ props.item.date | formatDate }}</td>
                  <td class="text-xs-left">                    
                    <span v-if="props.item.isLogin">
                      <v-btn flat icon color="grey darken-1">
                        <v-icon>power</v-icon>
                      </v-btn>Login
                    </span>
                    <span v-else>
                      <v-btn flat icon color="grey darken-1">
                        <v-icon>power_off</v-icon>
                      </v-btn>Logout
                    </span>
                  </td>
                  <td class="text-xs-left">{{ props.item.extension }}</td>
                  <td class="text-xs-left">{{ props.item.resultado }}</td>
                  <td class="text-xs-left">{{ props.item.info }}</td>
                  <td class="text-xs-left">
                    <i v-if="props.item.resultado" style="color: #7CB342;" class="material-icons">done</i>
                    <i v-else  style="color: #FF8A80;" class="material-icons">error</i>
                  </td>
                </tr>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Su búsqueda de "{{ searchHistory }}" no ha obtenido resultados.
              </v-alert>
            </v-data-table>
          </v-card>

        </v-card-text>

        <v-card-actions>      
          <v-switch
            @change="controlExtensionCalipso"
            color="blue"
            label="EL AGENTE RECIBIRÁ TRABAJOS DE CALIPSO"
            v-model="isExtensionCalipso"
            style="margin-left: 20px; font-weight: bold;"
          ></v-switch>                                
          <v-spacer></v-spacer>
          <v-btn color="blue" flat="flat" @click="dialog_info_login = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> 

    <!-- DIALOG INFO QUEUES AND AGENTE -->
    <v-dialog v-model="dialog" max-width="60%">
      <v-card>
        <v-card-title>
          <span class="title">{{dialog_title}}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="headline">
          <pre>{{dialog_content}}</pre>
        </v-card-text>
        <v-card-actions>
          <v-btn 
            v-if="infoExtension"
            style="background: linear-gradient(45deg,#239FE9,#44D5F3); color: white;" 
            flat="flat" @click="dialog = false, getInfoLoginHistory()">Ver histórico de login/logout</v-btn>           
          <v-spacer></v-spacer>
          <v-btn color="blue" flat="flat" @click="dialog = false">Cerrar</v-btn>          
        </v-card-actions>
      </v-card>
    </v-dialog>    

    <!-- DIALOG ADD AGENT QUEUE -->
    <v-dialog v-model="dialog_add_agent_queue" scrollable max-width="350px">
      <v-card>
        <v-card-title>
          Cola {{current_queue_add}}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 150px; padding: 25px;">
          <v-select
            :items="extensiones"
            item-text="extension"
            item-value="extension"
            v-model="new_agent_queue"
            color="blue"
            label="AGENTE A AÑADIR"
            autocomplete
          ></v-select>          
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey" flat @click.native="dialog_add_agent_queue = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn 
          style="background: linear-gradient(45deg,#239FE9,#44D5F3); color: white;" flat dark
            :disabled="!new_agent_queue"
            @click.native="loginColas()">Añadir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG LOGIN AGENT -->
    <v-dialog v-model="dialog_add_agent_login" scrollable max-width="350px">
      <v-card>
        <v-card-title>
          LOGIN AGENTE
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 150px; padding: 25px;">
          <v-select
            :items="extensiones"
            item-text="extension"
            item-value="extension"
            v-model="new_agent_login"
            color="blue"
            label="AGENTE PARA LOGUEAR"
            autocomplete
          ></v-select>          
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" flat @click.native="dialog_add_agent_login = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn 
          style="background: linear-gradient(45deg,#239FE9,#44D5F3); color: white;" flat 
            :disabled="!new_agent_login"
            @click.native="loginExtension()">Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Botón flotante -->
    <v-fab-transition v-if="admin">
    <v-tooltip left>
    <v-btn
      slot="activator"
        dark
        fab
        fixed
        bottom
        right        
        @click="new_agent_login = null, dialog_add_agent_login = true"
        style="background: rgba(0,0,0,0.30)">
        <v-icon>person_add</v-icon>
    </v-btn>
    <span>LOGIN DE AGENTE EN LAS COLAS EN LAS QUE ESTÉ CONFIGURADO</span>
    </v-tooltip>     
    </v-fab-transition>

    <v-snackbar
      v-model="snackbar"
      color="green"
      :multi-line="true"
      :timeout="3000">
      <span style="margin-left: 20px">{{ text.toUpperCase() }}</span>
    </v-snackbar>  

    <v-footer color="transparent" app inset style="padding-left: 35px; bottom: 5px !important;">
      <i v-if="conected" class="material-icons" style="color: #23de2a; font-size: 30px">compare_arrows</i>
      <i v-else class="material-icons" style="color: #FF5252; font-size: 30px">error</i>
      <span v-if="conected" style="margin-left: 10px; color: white; font-size: 18px;">Conectado</span>
      <span v-else style="margin-left: 10px; color: white; font-size: 18px;">No conectado</span>
    </v-footer>

  </v-container>
</template> 

<script>
 
import axios from 'axios'

export default {
    data () {
      return {                         
            token: null,
            admin: null,
            window_height: 700,
            colas_height: 300,
            login_height: 300,
            login_list_height: 100,
            login_calipso_height: 300,
            login_list_calipso_height: 100,
            colas: [],
            extensiones: [],          
            view_filter_login: false,
            view_filter_login_calipso: false,
            view_filter_queues: false,
            filterExtension: '',
            last_members: [],
            dialog: false,
            dialog_title: '',
            dialog_content: '',
            dialog_info_login: false,
            dialog_login: false,
            infoExtension: false,
            usuario: '',
            password: '',
            current_extension: null,
            current_extension_login: false,
            current_password: '',
            search: '',
            searchHistory: '',
            conected: false,
            isExtensionCalipso: false,
            dialog_add_agent_queue: false,
            new_agent_queue: null,
            current_queue_add: null,
            filterExtensionAddQueue: '',
            dialog_add_agent_login: false,
            new_agent_login: null,
            snackbar: false,
            text: '',

            headers: [
              { text: 'Fecha', align: 'left', value: 'date', sortable: true },
              { text: 'Acción', value: 'isLogin', sortable: true },
              { text: 'Extensión', value: 'extension', sortable: false },
              { text: 'Resultado', value: 'resultado', sortable: true },
              { text: 'Info', value: 'info', sortable: false },
              { text: '', sortable: false },
            ],
            pagination: {
              sortBy: 'date',
              descending: true
            },
            login_history: [],
            
            drawer: false,
            items: [
              { title: 'Home', icon: 'dashboard' },
              { title: 'About', icon: 'question_answer' }
            ],
            right: true,
            
            showQueueCalipso: false,
            calipsoStatus: true

      }
    },

    sockets:{
      connect: function(){
        console.log('[INFO] Socket connected.');
        this.socket_connected = true
        this.conected = true
      }   
    },

    mounted(){
      let vm = this
      this.admin = this.$store.state.admin
      this.token = this.$localStorage.get('cocToken')
      this.window_height = window.innerHeight - 150  
      this.colas_height = window.innerHeight/2.8  
      this.login_height = window.innerHeight - 150
      this.login_list_height = this.login_height - 78   
      this.login_calipso_height = this.colas_height + 70    
      this.login_list_calipso_height = this.colas_height
      this.scrollMove = this.$refs['scrollMove']  
      this.colas = this.$store.state.COLAS 
      this.showQueueCalipso = this.$store.state.showQueueCalipso

      this.getExtensiones()
 
    },    

    created: function (){

        axios.defaults.headers.common = {'Authorization': `bearer ${this.$localStorage.get('elecnorToken')}`}
        
        this.$options.sockets.evento = (data) => {
          // console.log("[Socket.io]", data.evento)
          switch (data.evento) {        
            case 'entraCola':
              this.tratarEventoEntraCola(data)
              break;
            case 'abandonaCola':
              this.tratarEventoAbandonaCola(data)
              break;
            case 'enlazaLlamada':
              this.tratarEventoEnlazaLlamada(data)
              break;  
            case 'queueShow':
              this.queueShow(data)
              break; 
            case 'login':
              this.tratarEventoLoginLogout(data)
              break; 
            case 'logout':
              this.tratarEventoLoginLogout(data)
              break; 
            case 'calipsoStatus':
              this.tratarEventoCalipsoStatus(data)
              break; 

            default:
              break;
          }
          this.conected = true
        }

    },

    computed: {

      theme(){        
        return this.$store.state.fondoDialog
      },

      fondoTitle(){
        return this.$store.state.fondoTitle
      },    

      filterLoginHistory: function () {        
        if (this.searchHistory !== '') {
          return this.login_history.filter(data => {
            let search = this.searchHistory.toLowerCase()
            let f = this.$options.filters.formatDate(data.date).toLowerCase()
            let info = 'true'
            if (!data.resultado) info = 'false'            
            return (
                (f.indexOf(search) > -1) 
                || (data.extension.indexOf(search) > -1)
                || ((data.info.respuesta).toLowerCase().indexOf(search) > -1)
                || (info.indexOf(search) > -1)
              )
          })
        } else {
          return this.login_history
        }
      }, 

      filterExtensionesColas: function () {        
        if (this.filterExtension !== '') {
          return this.extensiones.filter(agente => {   
            return agente.extension === this.filterExtension      
          })
        } else {
          return this.extensiones.filter(agente => {  
            return true
          })
        }
      },        

      filterExtensionesCalipso: function () {
        if (this.filterExtension !== '') {
          return this.extensiones.filter(agente => {
            return agente.calipso && agente.extension === this.filterExtension      
          })
        } else {
          return this.extensiones.filter(agente => {
            return agente.calipso     
          })
        }
      },  
      
      getStyleAgenteQueue: function(){
        return function (agente) {          
          if (!agente.registrado) return 'height: 40px; background: linear-gradient(45deg,#476892,#211c22); border-radius: 5px; border: 0.5px solid #ececec;color: white'
          else if (agente.paused) return 'height: 40px; background: #ccc; border-radius: 5px; border: 0.5px solid #ececec; color: white'          
          else if (agente.busy) return 'height: 40px; background: linear-gradient(45deg,#FD5A49,#FDDC98); border-radius: 5px; border: 0.5px solid #ececec;color: white'          
          else if (agente.in_call) return 'height: 40px; background: linear-gradient(45deg,#FD5A49,#FDDC98); border-radius: 5px; border: 0.5px solid #ececec;color: white'          
          else return 'height: 40px; background: linear-gradient(45deg,#239FE9,#44D5F3); border-radius: 5px; border: 0.5px solid #ececec; color: white'      
        }
      },

      getStyleTitleCola: function(){
        return function (cola) {
          if (cola === 'Contingencia' && this.calipsoStatus) return 'border-radius: 3px; background: linear-gradient(45deg,#ccc,#ccc)'
          else return 'border-radius: 3px; background: linear-gradient(45deg,#239FE9,#44D5F3)'      
        }
      },

      filterAgentesLibresColas: function(){
        return function (cola) {
          if (this.filterExtension !== '') {
            return cola.agentes.filter(item => {                        
              return ((!item.in_call && item.registrado && !item.busy && !item.paused) && ''+item.extension === this.filterExtension)
            })
          } else {          
            return cola.agentes.filter(item => {                        
              return !item.in_call && item.registrado && !item.busy && !item.paused
            })            
          }                      
        } 
      },

      filterAgentesEnLlamadaColas: function(){
        return function (cola) {
          if (this.filterExtension !== '') {
            return cola.agentes.filter(item => {                        
              return (item.in_call && ''+item.extension === this.filterExtension)
            })
          } else {          
            return cola.agentes.filter(item => {                        
              return item.in_call
            })            
          }                      
        } 
      },

      filterAgentesPausadosColas: function(){
        return function (cola) {
          if (this.filterExtension !== '') {
            return cola.agentes.filter(item => {                        
              return (item.paused && ''+item.extension === this.filterExtension)
            })
          } else {          
            return cola.agentes.filter(item => {                        
              return item.paused
            })            
          }                      
        } 
      },

      filterAgentesOcupadosNoRegistradosColas: function(){
        return function (cola) {
          if (this.filterExtension !== '') {
            return cola.agentes.filter(item => {                        
              return ((!item.in_call && (!item.registrado || item.busy)) && ''+item.extension === this.filterExtension)
            })
          } else {          
            return cola.agentes.filter(item => {                        
              return !item.in_call && (!item.registrado || item.busy)
            })            
          }                      
        } 
      },

      numeroAgentesDisponibles: function(){
        return function (cola) {  
          let n = 0        
          for (let index = 0; index < cola.agentes.length; index++) {
            const a = cola.agentes[index];    
            if (a.registrado && !a.in_call && !a.busy && !a.paused) n++        
            if (index === (cola.agentes.length-1)) {
              return n    
            }
          }  
        }
      },

      computadaConParametros: function(){
        return function (param) {
            return param  
        }
      }

    },

    methods: {

      loginExtension(){
        for (let index = 0; index < this.extensiones.length; index++) {
          const ext = this.extensiones[index]            
          if (ext.extension === ''+this.new_agent_login) {              
            this.usuario = ext.operador
            this.password = ext.password
            this.current_extension = ext.extension
            this.login()
            this.dialog_add_agent_login = false
          }
        }
      },

      login(){
        let vm = this          
        axios.put(vm.$store.state.URL_API_CALIPSO+'/login/'+vm.usuario+'/'+vm.password+'/'+vm.current_extension+'/calipso')
            .then(function (response) {                  
                vm.dialog_login = false
            })
            .catch(function (error) {
                console.log('[ERROR]' + error.message)
                vm.dialog_login = false
            }); 
      }, 

      logout(){
        let vm = this
        axios.put(vm.$store.state.URL_API_CALIPSO+'/logout/'+vm.usuario+'/'+vm.password+'/'+vm.current_extension+'/calipso')
            .then(function (response) {                  
                vm.dialog_login = false
            })
            .catch(function (error) {
                console.log('[ERROR]' + error.message)
                vm.dialog_login = false
            });
      },

      openAddAgentQueue(cola){
        this.current_queue_add = cola
        this.new_agent_queue = null
        this.dialog_add_agent_queue = true
      },

      prevLogoutColas(cola, extension){
        this.current_queue_add = cola
        this.new_agent_queue = extension
        this.logoutColas()
      },

      loginColas() {
        let vm = this
        axios.put(this.$store.state.URL_API_CALIPSO+'/loginColas/'+vm.new_agent_queue+'/'+vm.current_queue_add+'/calipso/false')
            .then(function (response) {                  
                //console.log(response)
                vm.text = 'Agente añadido a la cola'
                vm.snackbar = true
                vm.dialog_add_agent_queue = false
            })
            .catch(function (error) {
                console.log('[ERROR]' + error.message)                    
            }); 
      },

      logoutColas() {
        let vm = this
        axios.delete(this.$store.state.URL_API_CALIPSO+'/loginColas/'+vm.new_agent_queue+'/'+vm.current_queue_add+'/calipso')
            .then(function (response) {                  
                //console.log(response)   
                vm.text = 'Agente eliminado de la cola'
                vm.snackbar = true                                 
            })
            .catch(function (error) {
                console.log('[ERROR]' + error.message)                    
            }); 
      },        

      pausar(cola, item, on){         
        if (on) {
          axios.put(this.$store.state.URL_API_CALIPSO+'/pausaColas/'+item.extension+'/'+cola+'/calipso')
              .then(function (response) {                  
                  item.paused = true
              })
              .catch(function (error) {
                  console.log('[ERROR]' + error.message)                    
              }); 
        } else {
          axios.put(this.$store.state.URL_API_CALIPSO+'/reanudaColas/'+item.extension+'/'+cola+'/calipso')
              .then(function (response) {                  
                  item.paused = false
              })
              .catch(function (error) {
                  console.log('[ERROR]' + error.message)                    
              }); 
        }
      },        

      controlExtensionCalipso(){          
        let vm = this
        axios.put(vm.$store.state.URL_API_CALIPSO+'/setExtensionCalipso/'+vm.current_extension+'/'+vm.isExtensionCalipso)
            .then(function (response) {
                //console.log('Login:', response.data)
                vm.getExtensiones()
                vm.dialog_login = false
            })
            .catch(function (error) {
                console.log('[ERROR]' + error.message)
                vm.dialog_login = false
            });
      }, 

      getExtensiones() {
        let vm = this
        axios.get(vm.$store.state.URL_API_CALIPSO+'/getExtensiones')
            .then(function (response) {
                // console.log('getExtensiones:', response.data)
                vm.extensiones = response.data
                if (vm.dialog_info_login) {
                  for (let index = 0; index < vm.extensiones.length; index++) {
                    const ext = vm.extensiones[index]                      
                    if (ext.extension === vm.current_extension) {
                      vm.getLoginHistory(ext)
                      break
                    }                    
                  }                    
                }
            })
            .catch(function (error) {
                console.log('[ERROR]' + error.message)
            }); 
      },

      infoColasExtension(extension){          
        for (let index = 0; index < this.extensiones.length; index++) {
          const ext = this.extensiones[index];
          if (ext.extension === ''+extension){              
            let info = ''
            if (ext.colas.length === 0) {
              this.dialog_title = 'La extensión "'+extension+'" NO está configurada en DB para ninguna cola'
              this.dialog_content = 'Esta extensión ha sido logueada en esta cola de forma manual.'
              this.dialog = true
              this.infoExtension = true
              this.current_extension = extension
            }
            for (let n = 0; n < ext.colas.length; n++) {
              const c = ext.colas[n];
              info = info + c + '\n'
              if (n === (ext.colas.length - 1)) {
                this.dialog_title = 'La extensión "'+extension+'" está configurada para las colas:'
                this.dialog_content = info
                this.dialog = true
                this.infoExtension = true
                this.current_extension = extension
              }
            }
          }            
        }
      },

      tratarEventoEntraCola(evento){

        // empresa: "calipso"
        // evento: "entraCola"
        // idLlamada: "1547812512.257822"
        // nombreCola: "UGC_NORTE"
        // numeroUsuario: "945275024"
        // posCola: "1"

        for (let index = 0; index < this.colas.length; index++) {
          const cola = this.colas[index];
          if (cola.name === evento.nombreCola) {
            let llamada = {
              number: evento.numeroUsuario,
              idLlamada: evento.idLlamada,
              posCola: evento.posCola
            }
            if (cola.llamadas.indexOf(llamada) === -1) cola.llamadas.push(llamada)           
          }
        }

      },

      tratarEventoAbandonaCola(evento){

        // empresa: "calipso"
        // evento: "abandonaCola"
        // idLlamada: "1547816483.260082"
        // nombreCola: "NMME"
        // numeroUsuario: "606321346"
        // posCola: "1"
        // tiempoEspera: "11"

        for (let index = 0; index < this.colas.length; index++) {
          const cola = this.colas[index];
          if (cola.name === evento.nombreCola) {
            for (let n = 0; n < cola.llamadas.length; n++) {
              const llamada = cola.llamadas[n];
              if (llamada.idLlamada === evento.idLlamada) {
                cola.llamadas.splice(n, 1)
              }
            }
          }
        }

      },

      tratarEventoEnlazaLlamada(evento){

        // cliAgente: "284"
        // empresa: "calipso"
        // evento: "enlazaLlamada"
        // idLlamada: "1547812550.257835"
        // idOriginal: "1547812550.257835"
        // nombreCola: "UGC_VALLADOLID"
        // numeroUsuario: "685547351"
        // tiempoEspera: "4"

        for (let index = 0; index < this.colas.length; index++) {
          const cola = this.colas[index];
          if (cola.name === evento.nombreCola) {
            for (let n = 0; n < cola.llamadas.length; n++) {
              const llamada = cola.llamadas[n];
              if (llamada.idLlamada === evento.idLlamada) {
                cola.llamadas.splice(n, 1)
              }
            }
          }
        }

        //console.log('Enlaza llamada:', evento)
      },   

      tratarEventoLoginLogout(evento){
        this.getExtensiones()          
      },

      tratarEventoCalipsoStatus(evento){  
        this.calipsoStatus = evento.status     
      },

      getInfoLoginHistoryExtension(extension) {          
        for (let index = 0; index < this.extensiones.length; index++) {
          const ext = this.extensiones[index]            
          if (ext.extension === ''+extension) {

            let info = ''
            if (ext.colas.length === 0) {
              this.dialog_title = 'NO está configurada en DB para ninguna cola'
              this.dialog_content = 'Esta extensión ha sido logueada en esta cola de forma manual.'
              //this.dialog = true
              this.infoExtension = true
              this.current_extension = extension
            }
            for (let n = 0; n < ext.colas.length; n++) {
              const c = ext.colas[n];
              info = info + c + '\n'
              if (n === (ext.colas.length - 1)) {
                this.dialog_title = 'Está configurada para las colas:'
                this.dialog_content = info
                //this.dialog = true
                this.infoExtension = true
                this.current_extension = extension
              }
            }

            this.getLoginHistory(ext)          
            break  
          }
        }

      },

      getInfoLoginHistory() {          
        for (let index = 0; index < this.extensiones.length; index++) {
          const ext = this.extensiones[index]            
          if (ext.extension === ''+this.current_extension) {
            this.getLoginHistory(ext)          
            break  
          }
        }
      },
      
      getLoginHistory(item) {
        let vm = this
        vm.current_extension_login = item.login
        vm.current_extension = item.extension
        vm.current_password = item.password
        vm.password = item.password
        vm.isExtensionCalipso = item.calipso
        vm.usuario = '9' + item.extension          
        vm.login_history = []
        axios.get(vm.$store.state.URL_API_CALIPSO+'/getLoginHistory/'+vm.current_extension)
            .then(function (response) {
              //console.log('getLoginHistory:', response.data)                  
              if (response.data){
                for (let index = 0; index < response.data.length; index++) {
                  const data = response.data[index];
                  let item = {
                    date: data.created_at, isLogin:data.isLogin, extension: data.extension, resultado: data.result, info: data.info[0]
                  }
                  vm.login_history.push(item)
                }
              }
            })
            .catch(function (error) {
                console.log('[ERROR]' + error.message)
            });           
        vm.dialog_info_login = true
      },

      getStyleExtension(agente){
        if (agente.login) return 'height: 40px; background: linear-gradient(45deg,#6FE594,#27A47C); border-radius: 5px; border: 0.4px solid green; color: white'
        else return 'height: 40px; background: linear-gradient(45deg,#F1467A,#FB949E);border-radius: 5px; border: 0.4px solid #FB949E; color: white'
      }, 

      getStyleLlamadas(llamada) {          
        return 'height: 40px; background: linear-gradient(45deg,#239FE9,#44D5F3); border-radius: 5px;border: 0.5px solid #ececec; color: white'
      },

      queueShow (data){

        let vm = this

        let content = data.data.content  
        let cola = ''                
        let info = ''                
        let row = []
        for (let index = 0; index < content.length; index++) {
          const element = content[index];
          
          if (element.indexOf('strategy') !== -1) {
            row = element.split(' ')              

            //console.log(cola + ' Last Members:', vm.last_members)
            //=> Primero sacamos de la cola anterior los agentes que ya no están y luego inicializamos la nueva cola
            for (let j = 0; j < vm.colas.length; j++) {
              const c = vm.colas[j];
              if (cola === c.name) { 
                c.info = info                                              
                for (let n = 0; n < c.agentes.length; n++) {
                  const agente = c.agentes[n];
                  if (vm.last_members.indexOf(agente.extension) === -1) {                                                            
                    c.agentes.splice(n,1)                              
                  }
                }
              }
              if (j === (vm.colas.length - 1)){   
                info = (element.split('strategy'))[0] + ' strategy.'                     
                vm.last_members = []
                cola = row[0]                     
              }
            }  
                          
          } else if (cola && cola !== '' && element.indexOf('SIP/') !== -1) {                           
            vm.addMemberQueue(cola, element)
          } 

          //Refresh
          if (index === (content.length - 1)){
            vm.$forceUpdate();
          }

        }

      },

      addMemberQueue (cola, row){
        let vm = this
        if (cola !== '') {
                      
          try {              

            // Obtener la extensión
            let info = (row.split('SIP/'))[1]
            info = info.split(' ')
            info[0] = info[0].replace('178.33.162.9', 'trunk')
            let ext = parseInt(info[0])

            if (!isNaN(ext)) {

              let agente = { extension: ext, login: vm.isLogin(ext), calipso: vm.isCalipso(ext), in_call: false, pausado: false, busy: vm.isBusy(ext), registrado: true }
              
              vm.last_members.push(agente.extension)
              
              /*
                (Unavailable) -> No registrada
                (Not in use)  -> Logueda y libre
                (In use)      -> Logueda y libre
                (in call)     -> En llamada
                (paused)      -> Pausada
                (Ring+Inuse)  -> 
                (Ringing)     -> 
                (Busy)        -> (ocupada)
              */

              // Obtenemos el estado de la extensión (Registrada, pausada, etc...)              
              if (row.indexOf('(Unavailable)') !== -1) agente.registrado = false
              if (row.indexOf('(in call)') !== -1 || row.indexOf('(In use)') !== -1) agente.in_call = true
              if (row.indexOf('(paused)') !== -1) agente.paused = true
              if (row.indexOf('(Busy)') !== -1) agente.busy = true

              // Añadimos el agente a la cola correspondiente
              for (let index = 0; index < vm.colas.length; index++) {
                const item_cola = vm.colas[index];
                
                if (cola === item_cola.name) {
                      
                  if (item_cola.extensiones.indexOf(agente.extension) === -1) {
                                        
                    item_cola.extensiones.push(agente.extension)
                    item_cola.agentes.push(agente)
                    item_cola.agentes = item_cola.agentes.sort(function(a,b){ return a.extension-b.extension })

                  } else {

                    if (item_cola.agentes.length === 0) {                      
                      item_cola.agentes.push(agente) 
                      item_cola.agentes = item_cola.agentes.sort(function(a,b){ return a.extension-b.extension })
          
                    } else {
                      
                      for (let k = 0; k < item_cola.agentes.length; k++) {
                        let agt = item_cola.agentes[k];                     
                        if (agt.extension === agente.extension) {
                          item_cola.agentes[k].registrado = agente.registrado
                          item_cola.agentes[k].paused = agente.paused
                          item_cola.agentes[k].busy = agente.busy
                          item_cola.agentes[k].in_call = agente.in_call
                          item_cola.agentes[k].login = agente.login
                          item_cola.agentes[k].calipso = agente.calipso
                        }
                      }

                    }

                  }
                  
                }
              }

            }

          } catch (error) { }
        }
      },

      isLogin(extension){
        for (let index = 0; index < this.extensiones.length; index++) {
          const ext = this.extensiones[index]            
          if (ext.extension === ''+extension) {              
            return ext.login
          }
        }
      },

      isCalipso(extension){
        for (let index = 0; index < this.extensiones.length; index++) {
          const ext = this.extensiones[index]            
          if (ext.extension === ''+extension) {              
            return ext.calipso
          }
        }
      },

      isBusy(extension){
        for (let index = 0; index < this.extensiones.length; index++) {
          const ext = this.extensiones[index]            
          if (ext.extension === ''+extension) {              
            return ext.busy
          }
        }
      },

      openDialogCola(cola) {
        this.dialog_title = 'Información de la cola "'+cola.name+'"'
        this.dialog_content = cola.info
        this.dialog = true
        this.infoExtension = false
      }

    },

    filters: {
      formatDate: function (date) {
        let a = new Date(date)
        //let months = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic']
        let months = ['01','02','03','04','05','06','07','08','09','10','11','12']
        let year = a.getFullYear()
        let month = months[a.getMonth()]
        let day = a.getDate()        
        let hour = a.getHours()
        if (hour<10) hour = '0'+hour
        let min = a.getMinutes()
        if (min<10) min = '0'+min
        let sec = a.getSeconds()
        if (sec<10) sec = '0'+sec
        return day + '/' + month + '/' + year + ' ' + hour + ':' + min + ':' + sec + ' h'
      },
    }, 

}

</script>

<style scoped>
    .danger {
      background: #FFCDD2
    }

    .lineGrey {

    }
    .texto {
        font-size: 17px !important; font-weight: normal !important;
    }
    .container {
        -webkit-box-flex: 1 !important;
        -ms-flex: 1 1 100% !important;
        flex: 1 1 100% !important;
        margin: auto !important;
        padding: 16px !important;
        padding-top: 0px !important;
        width: 100% !important;
    }
    ::-webkit-scrollbar {
        width: 12px !important;
    }
    
    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3) !important; 
        border-radius: 10px !important;
    }
    
    ::-webkit-scrollbar-thumb {
        border-radius: 10px !important;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5) !important; 
    }
 
    .scrollform {
        overflow-y: scroll !important
    }    

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue